import { computed } from 'vue'
import { useAccountStore } from '@/stores/account'
import type { AccessKycOptions } from '@/shared/common/types/accessKyc.type'
import { KycStatus } from '@/types/KycCompliance';


export function useAccessKyc(options?: AccessKycOptions) {
  const account = useAccountStore();

  const { b2bUser, company } = account.kycStatus;

  function checkTypeAccess(
    optionsList: string[] | undefined,
    currentStage: KycStatus | undefined
  ): boolean {
    if (!optionsList?.length && !currentStage) {
      return true;
    }
    
    if (optionsList?.length) {
      if (optionsList.includes('ANY')) return true;
      if (currentStage && optionsList.includes(currentStage)) return true;
    }

    return false;
  }

  const hasAccessCompany = computed(() => {
    return checkTypeAccess(
      options?.company,
      company?.kycStage1
    )
  })

  const hasAccessUser = computed(() => {
    return checkTypeAccess(
      options?.user,
      b2bUser?.kycStage1
    )
  })

  const hasAccess = computed(() => {
    return hasAccessCompany.value && hasAccessUser.value;
  })

  return {
    hasAccessCompany,
    hasAccessUser,
    hasAccess,
  }
}
